import createDOMPurify from 'dompurify';

export const agreementHtmlAllowedTags = [
    'p',
    'br',
    'hr',
    'span',
    'div',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'sub',
    'sup',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ul',
    'ol',
    'li',
    'blockquote',
    'a',
    'img',
    'table',
    'caption',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'th',
    'td'
];

export const agreementHtmlAllowedAttributes = [
    'href',
    'title',
    'src',
    'alt',
    'width',
    'height',
    'colspan',
    'rowspan',
    'style'
];

const httpMailtoOrRelativeUrl = /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i;

const textAlignment = /^\s*text-align\s*:\s*(left|right|center|justify)\s*$/i;

function onlyTextAlignment(style: string): string {
    const alignment = style
        .split(';')
        .map((declaration) => textAlignment.exec(declaration))
        .filter((match): match is RegExpExecArray => match !== null)
        .pop();

    return alignment ? `text-align: ${alignment[1].toLowerCase()}` : '';
}

const purifier = createDOMPurify(window);

purifier.addHook('uponSanitizeAttribute', (node, data) => {
    if (data.attrName !== 'style') {
        return;
    }

    data.attrValue = onlyTextAlignment(data.attrValue);
    data.keepAttr = data.attrValue !== '';
});

export function sanitizeAgreementHtml(html: string | null | undefined): string {
    if (!html) {
        return '';
    }

    return purifier.sanitize(html, {
        ALLOWED_TAGS: [...agreementHtmlAllowedTags, '#text'],
        ALLOWED_ATTR: agreementHtmlAllowedAttributes,
        ALLOWED_URI_REGEXP: httpMailtoOrRelativeUrl,
        KEEP_CONTENT: false
    }) as string;
}
